<template>
    <div class="fh-centent">
        <fhHeader  @changeNev="changeNev" ref="fhHead"/>
        <div class="container">
            <topNav/>
            <Home v-if="$route.path === '/home'"/>
            <LeftNav v-show="$route.path != '/home'" ref="child"/>
        </div>
        <fhFooter/>
    </div>
</template>

<script>
import fhHeader from './header'
import fhFooter from './footer'
import topNav from './topNav'
import LeftNav from './leftNav'
import Home from '@/views/home/home.vue'
export default {
    data() {
        return {
            isHome: false
        }
    },
    components: {
        fhHeader,
        fhFooter,
        topNav,
        LeftNav,
        Home
    },
    methods:{
        changeNev(index,index1){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.$refs.child.initActive(index,index1);
        }
    }
}
</script>

<style src="@/assets/style/fh_form.css"></style>
<style src="@/assets/style/styles.scss" lang="scss"></style>
<style src="@/assets/style/nav_left.scss" lang="scss"></style>